import {PageWrapper} from "../components/PageWrapper";
import SiteHeader from "../components/SiteHeader";
import NavBar from "../components/NavBar";
import {MainBody} from "../components/MainBody";
import {Main} from "../components/Main";
import ImageSlider from "../components/ImageSlider";
import Line from "../components/Line";
import Footer from "../components/Footer";
import styled from "styled-components";


export default function Imprint() {


    return (
        <PageWrapper>
            <SiteHeader caption={"Impressum"}/>
            <NavBar/>
            <MainBody>
                <Main>
                    <ImageSlider small/>
                    <Heading>Imperessum</Heading>
                    {/*<Subheading>Ihr Partner für Tiefbau und Glasfaser in ganz Deutschland</Subheading>*/}
                    <ContentWrapper>
                        <h3>
                            Kontakt:
                        </h3>
                        <p>
                            DaFa Rhein-Sieg GmbH
                            Geschäftsführer: H. Zeycan
                        </p>
                        <p>
                            Vorgebigsblick 30
                        </p>
                        <p>
                            53844 Troisdorf
                        </p>
                        <p>
                            Telefon: 02241-905 27 02
                        </p>
                        <p>
                            Fax: 02241-905 27 03
                        </p>
                        <p>
                            Mobil: 0172 – 36 196 28
                        </p>
                        <p>
                            Email: info@dafa-dachtechnik.de
                        </p>
                        <p>
                            Internet: www.dafa-dachtechnik.de
                        </p>
                        <p>
                            Haftungsausschluss:
                            <br></br>
                            <br></br>
                            Diese Internetseite wurde mit größtmöglicher Sorgfalt zusammengestellt. Trotzdem kann keine
                            Gewähr für die Fehlerfreiheit und Genauigkeit der enthaltenen Informationen übernommen
                            werden. DaFa Rhein-Sieg GmbH stellt die Informationen ohne jegliche Zusicherung oder
                            Gewährleistung jedweder Art, sei sie ausdrücklich oder stillschweigend, zur Verfügung.
                            Sofern von dieser Internetseite auf andere Webseiten verwiesen wird, die von Dritten
                            betrieben werden, übernimmt DaFa Rhein-Sieg GmbH keine Verantwortung für deren Inhalte.
                        </p>
{/*                        <p>
                            Konzeption, Design & technische Umsetzung:
                            <br></br>
                            <br></br>
                            IT Service Deutschland <a className="isd" href="www.itservicedeutschland.de">www.itservicedeutschland.de</a>
                        </p>*/}
                    </ContentWrapper>
                </Main>
            </MainBody>
            <Line/>
            <Footer/>
        </PageWrapper>
    )
}

const Heading = styled.h2`
    font-size: 2.5rem;
    color: #1a202c;
    margin-bottom: 1rem;
    font-weight: 700;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: 768px) {
        flex-direction: column;
        gap: 0.5rem;
    }
    .isd{
        color: black;
    }
`;